//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
       cardTitle:{
           type: null,
           default: ()=>{
               return 'cardHeader'
           }
       },
       cardContent:{
           type: null,
           default: ()=>{
               return "cardContent"
           }
       },
       cardFooter:{
           type: null,
           default: ()=>{
               return "cardFooter"
           }
       },
       isHeader:{
           type: Boolean,
           default:()=>{
               return true
           }
       },
       isFooter:{
           type: Boolean,
           default:()=>{
               return true
           }
       }
    },
    name: "sm-card",
    data() {
        return {

        }
    },
    components: {

    }
}



// WEBPACK FOOTER //
// ./node_modules/smart_webview_ui/src/components/sm_card/sm_card.vue